module.exports = __webpack_public_path__ + "img/facebook-logo-o.79158a1f.svg";